import Vue from 'vue'
require('bootstrap')
Vue.component('menu-component', require('./components/MenuComponent.vue').default);
const app = new Vue({
    el: '#vue_menu',
});
